import ReportProxy from '@/proxies/Reports/ReportProxy';

export default {
  data() {
    return {
      emailReportMethodName: 'contactsListingEmailReport',
    };
  },
  methods: {
    onSendEmailExcel() {
      if ('isRequestingNow' in this) {
        this.isRequestingNow = true;
      }

      const proxy = new ReportProxy()
        .setParameters(this.searchParams);
      proxy[this.emailReportMethodName]()
        .then(response => {
          this.$store.dispatch('page/displaySnackbar', {
            text: this.lang(this.$store, 'sap/listings.global.send_email_request_report'),
            color: 'pink darken-3',
            timeout: 6000,
          });
        })
        .catch(error => {
          switch (error.status) {
            case 422:
              setTimeout(() => {
                this.$store.dispatch('page/displaySnackbar', {
                  text: error.data.data.error,
                  color: 'red darken-3',
                  timeout: 6000,
                });
              }, 500);
              break;
            default:
              console.error(error);
              alert('Error while requesting');
              break;
          }
        })
        .finally(() => {
          if ('isRequestingNow' in this) {
            setTimeout(() => {
              this.isRequestingNow = false;
            }, 1000);
          }
        });
    },
  },
};
